import { GRID_SERVICE_NAME, GridServiceProvider } from './grid.service'
import { GRID_CONTEXT_MENU_SERVICE_NAME, GridContextMenuServiceProvider } from './grid.context-menu.service'

export const GRID_SERVICES_MODULE_NAME = 'simax.services.grid'

const gridServicesModule = angular.module(GRID_SERVICES_MODULE_NAME, [])

gridServicesModule.provider(GRID_SERVICE_NAME, GridServiceProvider)
gridServicesModule.provider(GRID_CONTEXT_MENU_SERVICE_NAME, GridContextMenuServiceProvider)
